import { render, staticRenderFns } from "./siding-home.vue?vue&type=template&id=eed6dca0&scoped=true"
import script from "./siding-home.vue?vue&type=script&lang=js"
export * from "./siding-home.vue?vue&type=script&lang=js"
import style0 from "./siding-home.vue?vue&type=style&index=0&id=eed6dca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed6dca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
